import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';
import MessageUtils from "../../utils/MessageUtils";

import {
    LOADING,
    LOAD_JOB_ITEMS_SUCCESS
} from '../types';

export const loadJobItems = (state) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/job/${state.id}/items`;

        axios().get(url)
            .then(response => loadJobItemsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:jobItemsActions.loadJobItemsFailure')));
    }
}

const loadJobItemsSuccess = (dispatch, response) => {
    dispatch({type: LOADING, payload: false});
    dispatch({type: LOAD_JOB_ITEMS_SUCCESS, payload: response.data});
}


// WEBPACK FOOTER //
// ./src/actions/jobhistory/JobItemsActions.js